// Shared mobile Redux store (extracted so router can hydrate without circular imports).
import { createStore, applyMiddleware } from "redux";
import { createPromise } from "redux-promise-middleware";
import mobileRootReducer from "modules/offline/rootReducer";

const createStoreWithMiddleware = applyMiddleware(createPromise())(createStore);

export const mobileStore = createStoreWithMiddleware(
  mobileRootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
